import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ChartComponent } from "ng-apexcharts";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import { of } from "rxjs";
import { delay } from "rxjs/operators";
import { color } from "html2canvas/dist/types/css/types/color";

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexMarkers,
  ApexStroke,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
  ApexOptions,
} from "ng-apexcharts";

@Component({
  selector: "app-mb-dashboard",
  templateUrl: "./mb-dashboard.component.html",
  styleUrls: ["./mb-dashboard.component.scss"],
})
export class MBDashboardComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;

  public chartOptions: any;
  public stackBarChart: any;
  public chartOptionsService: any;
  public chartOptionsQR: any;
  public chartInactive: any;
  public chartOptionsDonut: ApexOptions;
  public chartOptionsOpenReport: any;
  public chartOptionsMonthlyReport: any;
  public chartOptionsOpenBranchReport: any = [];

  data: any;
  dataTotal: any;
  dataStatistics: any;
  QRData: any;
  packageData: any;
  partnerOption = "MB";
  partnerOptions = [
    { value: "MB", label: "Đối tác MB" },
    { value: "VT", label: "Đối tác Viettel" },
  ];
  selectedOptionOpenReport = {
    type: "Gói dịch vụ",
    value: "package",
    tab: "day",
  };
  selectedMonthlyOption = { value: "device", type: "Số lượng loa" };
  selectedOpenBranchReport = { type: "Top 5 RM/UB" };

  loadingState: { [key: string]: boolean } = {
    chartInactive: false,
    chartQR: false,
    chartBranch: false,
    stackBarChart: false,
    chartOpenReport: false,
    chartMonthlyReport: false,
    chartOpenBranchReport: false,
  };
  selectedRange: { [key: string]: string } = {
    chartInactive: "5",
    chartQR: "day",
    chartBranch: "-1",
    stackBarChart: "",
  };

  // inactiveChart
  isLoading = false;

  timeRangesInactive = [
    { label: "5 ngày", value: "5" },
    { label: "15 ngày", value: "15" },
    { label: "30 ngày", value: "30" },
    { label: "60 ngày", value: "60" },
  ];
  timeRangesBranch = [
    { label: "Tất cả", value: "-1" },
    { label: "7 ngày", value: "7" },
    { label: "14 ngày", value: "14" },
    { label: "21 ngày", value: "21" },
    { label: "30 ngày", value: "30" },
  ];

  async updateChart(chartKey: string, range: any) {
    this.loadingState[chartKey] = true;
    this.selectedRange[chartKey] = range;

    try {
      let newData;

      if (chartKey === "chartInactive") {
        this.chartInactive = await Promise.resolve(this.getDataChartInactive());
      } else if (chartKey === "chartQR") {
        this.chartOptionsQR = await Promise.resolve(this.getDataChartTrans());
      } else if (chartKey === "chartBranch") {
        this.chartOptions = await Promise.resolve(this.getDataBranch());
      } else if (chartKey === "stackBarChart") {
        newData = await Promise.resolve(this.generateData(range));
        this.stackBarChart = await Promise.resolve(this.getDataBranch());
      } else if (chartKey === "chartOpenReport") {
        this.chartOptions = await Promise.resolve(this.getOpenReport());
      } else if (chartKey === "chartMonthlyReport") {
        this.chartOptions = await Promise.resolve(this.getMonthlyReport());
      } else if (chartKey === "chartOpenBranchReport") {
        this.chartOptions = await Promise.resolve(this.getOpenBranchReport());
      }
      await new Promise((resolve) => setTimeout(resolve, 500));
    } catch (error) {
      console.error(`Lỗi khi tải dữ liệu cho ${chartKey}:`, error);
    } finally {
      // this.loadingState[chartKey] = false;
    }
  }

  generateData(range: number): number[] {
    return Array.from({ length: 6 }, () => Math.floor(Math.random() * 100));
  }

  currentMonth: string;

  constructor(
    private eventService: EventService,
    private apiService: ApiService,
    private translate: TranslateService,
    private datePipe: DatePipe
  ) {
    const now = new Date();
    const monthNames = [
      "Tháng 01",
      "Tháng 02",
      "Tháng 03",
      "Tháng 04",
      "Tháng 05",
      "Tháng 06",
      "Tháng 07",
      "Tháng 08",
      "Tháng 09",
      "Tháng 10",
      "Tháng 11",
      "Tháng 12",
    ];
    this.currentMonth = monthNames[now.getMonth()];
  }

  ngOnInit(): void {
    this.getDataBranch();
    this.getDataStatistics();
    this.getDataTotal();
    this.getDataChartInactive();
    // this.getDataChartQr();
    console.log(this.role);

    this.getDataChartTrans();
    this.getOpenReport();
    this.getMonthlyReport();
    this.getOpenBranchReport();
  }
  fullname = JSON.parse(localStorage.getItem("currentUser"))["full_name"];
  role = JSON.parse(localStorage.getItem("currentUser"))["role"];
  onOptionSelected(option: any) {
    this.selectedOptionOpenReport = option;
    this.updateChart("chartOpenReport", null);
  }
  onOptionMonthlySelected(option: any) {
    this.selectedMonthlyOption = option;
    this.updateChart("chartMonthlyReport", null);
  }

  onOptionOpenBranchSelected(option: any) {
    this.selectedOpenBranchReport.type = option;
    this.updateChart("chartOpenBranchReport", null);
  }
  totalDevice;
  getDataBranch() {
    const urlBranch = "dashboard/development-report?timeFilter=";
    this.apiService
      .getList(
        urlBranch +
        this.selectedRange.chartBranch +
        "&partnerOption=" +
        this.partnerOption
      )
      .subscribe({
        next: (res) => {
          this.totalDevice = res?.metadata?.total?.total_device;
          const chartOptionsSeries = [
            res?.metadata?.total?.total_sold,
            res?.metadata?.total?.total_inventory,
            res?.metadata?.total?.total_returned,
            res?.metadata?.total?.total_recalled,
            res?.metadata?.total?.total_transfered,
          ];
          this.chartOptions = {
            series: chartOptionsSeries,
            chart: {
              width: 380,
              type: "donut",
            },
            labels: [
              "Thiết bị đã bán",
              "Thiết bị tồn kho",
              "Thiết bị trả lại",
              "Thiết bị thu hồi",
              "Thiết bị nhận từ chi nhánh",
            ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          };
          const stackBarChartData = {
            series: [
              {
                name: "Số thiết bị đã bán",
                data: res?.metadata?.results?.map((i) => i.total_sold) || [],
              },
              {
                name: "Số thiết bị tồn kho",
                data:
                  res?.metadata?.results?.map((i) => i.total_inventory) || [],
              },
              {
                name: "Số thiết bị trả lại",
                data:
                  res?.metadata?.results?.map((i) => i.total_returned) || [],
              },
              {
                name: "Số thiết bị thu hồi",
                data:
                  res?.metadata?.results?.map((i) => i.total_recalled) || [],
              },
              {
                name: "Số thiết bị nhận từ chi nhánh",
                data:
                  res?.metadata?.results?.map((i) => i.total_transfered) || [],
              },
            ],
            categories:
              res?.metadata?.results?.map((i) => `${i.label_1}`) || [],
          };

          this.stackBarChart = {
            series: stackBarChartData?.series,
            chart: {
              type: "bar",
              height:
                stackBarChartData?.categories?.length > 5
                  ? stackBarChartData?.categories?.length * 100
                  : stackBarChartData?.categories?.length * 200,
              stacked: true,
              stackType: "100%",
              toolbar: {
                show: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
                barHeight:
                  stackBarChartData?.categories?.length > 10 ? "50%" : "70%",
              },
            },
            stroke: {
              width: 1,
              colors: ["#fff"],
            },
            xaxis: {
              categories: res?.metadata?.results?.map((i) => `${i.label_1}`),
              labels: {
                style: {
                  fontSize: "12px",
                  whiteSpace: "break-spaces", // Giúp hiển thị xuống dòng
                },
              },
            },
            tooltip: {
              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                let category = res?.metadata?.results?.[dataPointIndex];
                return `<div style="padding: 5px;">
                          <strong>${category?.label_1}</strong><br/>
                          ${category?.label_2} <br/>
              ${w.config.series[seriesIndex].name}: <strong>${series[seriesIndex][dataPointIndex]}</strong> thiết bị
                        </div>`;
              },
            },
            fill: {
              opacity: 1,
            },
            legend: {
              position: "top",
              horizontalAlign: "left",
              offsetX: 40,
            },
          };
          this.loadingState.chartBranch = false;
        },
        error: (e) => {
          this.apiService.showToast(
            this.translate.instant("Lỗi dữ liệu"),
            this.translate.instant("Dữ liệu chi nhánh chưa được tải về"),
            "error"
          );
        },
      });
  }

  getDataStatistics() {
    this.apiService
      .getList("dashboard/statistics?partnerOption=" + this.partnerOption)
      .subscribe({
        next: (res) => {
          this.dataStatistics = res.metadata;

          const totalPackages = this.dataStatistics.totalPackages;
          const seriesData = [
            totalPackages.months_3,
            totalPackages.months_6,
            totalPackages.months_12,
          ];
          const totalAll = totalPackages.total_all;

          this.chartOptionsDonut = {
            series: seriesData,
            chart: { type: "donut", height: 350 },
            labels: ["03 tháng", "06 tháng", "12 tháng"],
            colors: ["#7B61FF", "#FF8F8F", "#5EC9F3"],
            legend: {
              position: "top",
            },
            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                const total = opts.w.globals.seriesTotals.reduce(
                  (a, b) => a + b,
                  0
                );
                const percentage = (
                  (opts.w.globals.series[opts.seriesIndex] / total) *
                  100
                ).toFixed(0);
                return `${opts.w.globals.series[opts.seriesIndex]
                  } (${percentage}%)`;
              },
            },
            tooltip: {
              y: {
                formatter: (val) => `${val} gói`,
              },
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    total: {
                      show: true,
                      label: "Tổng gói",
                      formatter: () => `${totalAll}`,
                    },
                  },
                },
              },
            },
          };
        },
        error: (e) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.translate.instant(e || "Lỗi tải dữ liệu")
          );
        },
      });
  }
  getDataTotal() {
    this.apiService
      .getList("dashboard/delay-v2?partnerOption=" + this.partnerOption)
      .subscribe({
        next: (res) => {
          this.dataTotal = res.metadata;
        },
        error: (e) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.translate.instant(e || "Lỗi tải dữ liệu")
          );
        },
      });
  }
  getDataChartQr() {
    this.loadingState.chartQR = true;
    this.apiService
      .getList("dashboard/mb/delayed-tasks?partnerOption=" + this.partnerOption)
      .subscribe({
        next: (res) => {
          this.QRData = {
            data: [
              {
                name: "Tổng giá trị giao dịch",
                type: "column",
                data: res.metadata.revenueOR7d.map((item) => item.total_amount),
              },
              {
                name: "Tổng số giao dịch",
                type: "line",
                data: res.metadata.revenueOR7d.map(
                  (item) => item.total_transactions
                ),
              },
            ],
            category: res.metadata.revenueOR7d.map((item) =>
              this.datePipe.transform(new Date(item.date), "dd/MM")
            ),
          };
        },
        error: (e) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.translate.instant(e || "Lỗi tải dữ liệu")
          );
        },
      });
    this.loadingState.chartQR = false;
  }
  getDataChartInactive() {
    this.loadingState.chartInactive = true;
    this.apiService
      .getList(
        `dashboard/inactive-workspace-rate?daysAgo=${this.selectedRange.chartInactive}&partnerOption=${this.partnerOption}`
      )
      .subscribe({
        next: (res) => {
          const months = res.metadata.months.map(
            (m: number) => `Tháng ${m.toString().padStart(2, "0")}`
          );
          const ratios = res.metadata.ratios;
          this.chartInactive = {
            chart: { type: "area", height: 350 },
            series: [{ name: "Tỷ lệ Inactive", data: ratios }],
            xaxis: { categories: months },
            yaxis: { labels: { formatter: (value) => value + "%" } },
            colors: ["#8979FF"],
            stroke: { curve: "smooth", width: 2, colors: ["#8979FF"] },
            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 0.5,
                opacityFrom: 0.7,
                opacityTo: 0,
                gradientToColors: ["#8979FF"],
                stops: [0, 100],
              },
            },
            dataLabels: { enabled: false },
            markers: { size: 5, hover: { size: 7 }, strokeWidth: 2 },
          };
          this.loadingState.chartInactive = false;
        },
        error: (e) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.translate.instant(e || "Lỗi tải dữ liệu loa inactive")
          );
        },
      });
  }
  getDataChartTrans() {
    this.loadingState.chartQR = true;
    this.apiService
      .getList(
        `dashboard/transaction?type=${this.selectedRange.chartQR}&partnerOption=${this.partnerOption}`
      )
      .subscribe({
        next: (res) => {
          const totalDays = res.metadata.labels.length;
          const totalTransactions = res.metadata.values.reduce(
            (a, b) => a + b,
            0
          );
          const totalAmount = res.metadata.counts.reduce((a, b) => a + b, 0);
          const avgTransactions = (totalTransactions / totalDays).toFixed(2);
          const avgAmount = (totalAmount / totalDays).toFixed(2);

          const dataTrans = {
            category: res.metadata.labels.map((label) =>
              this.selectedRange["chartQR"] === "day"
                ? `Ngày ${label}`
                : `Tháng ${label}`
            ),

            data: [
              {
                name: "Tổng giá trị giao dịch",
                type: "column",
                data: res.metadata.values, // Dữ liệu đúng
                yaxisIndex: 0, // Đưa về đúng trục
                color: "#8979FF",
              },
              {
                name: "Tổng số giao dịch",
                type: "line",
                data: res.metadata.counts, // Dữ liệu đúng
                yaxisIndex: 1, // Đưa về đúng trục
                color: "#F2785D",
              },
            ],
          };

          this.chartOptionsQR = {
            series: dataTrans.data,
            chart: {
              height: 400,
              type: "line",
            },
            legend: {
              show: true,
            },
            grid: {
              show: false,
            },
            stroke: {
              width: [0, 2],
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                endingShape: "rounded",
                colors: {
                  backgroundBarColors: ["#8979FF"],
                  backgroundBarOpacity: 1,
                },
              },
            },
            fill: {
              opacity: [1, 1],
            },
            title: {
              text: "Giao dịch QR",
              style: {
                fontSize: "14px",
                color: "#606060",
                fontWeight: "600",
                fontFamily: "open sans, Helvetica, Arial, sans-serif",
              },
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: [1],
            },
            labels: dataTrans.category,
            xaxis: {
              categories: dataTrans.category,
            },
            yaxis: [
              {
                title: {
                  text: "Tổng giá trị giao dịch",
                },
                axisBorder: {
                  show: true,
                },
                axisTicks: {
                  show: true,
                },
                labels: {
                  show: true,
                  formatter: function (val) {
                    return (
                      val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                      " VNĐ"
                    );
                  },
                },
              },
              {
                opposite: true,
                title: {
                  text: "Tổng số giao dịch",
                },
              },
            ],
            annotations: {
              yaxis: [
                {
                  y: avgAmount, // Đường trung bình cho tổng giá trị giao dịch
                  borderColor: "#00B69B",
                  strokeDashArray: 4,
                  label: {
                    position: "left",
                    borderWidth: 0,
                    style: {
                      color: "#FFFFFF",
                      background: "transparent",
                      fontSize: "14px",
                    },
                    text: "Trung bình giá trị",
                  },
                },
                {
                  y: avgTransactions, // Đường trung bình cho tổng số giao dịch
                  borderColor: "#FF928A",
                  strokeDashArray: 4,
                  label: {
                    position: "left",
                    borderWidth: 0,
                    style: {
                      color: "#FFFFFF",
                      background: "transparent",
                      fontSize: "14px",
                    },
                    text: "Trung bình giao dịch",
                  },
                },
              ],
            },
            tooltip: {
              y: {
                formatter: function (val, { seriesIndex }) {
                  return seriesIndex === 0
                    ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                    " VNĐ"
                    : val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                },
              },
            },
          };

          this.loadingState.chartQR = false;
        },
        error: (e) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.translate.instant(e || "Lỗi tải dữ liệu giao dịch")
          );
        },
      });
  }
  convertDateFormat(dateStr) {
    if (/^\d{2}-\d{2}$/.test(dateStr)) {
      const [month, day] = dateStr.split("-");
      return `${parseInt(day)}/${parseInt(month)}`;
    }
    return "Tháng " + dateStr;
  }

  getOpenReport() {
    this.loadingState.chartOpenReport = true;
    this.apiService
      .getList(
        `dashboard/new-open-report?partnerOption=${this.partnerOption}&&timeUnit=${this.selectedOptionOpenReport.tab}&&filter=${this.selectedOptionOpenReport.value}`
      )
      .subscribe({
        next: (res) => {
          let data: any;
          switch (this.selectedOptionOpenReport.type) {
            case "Gói dịch vụ":
              data = {
                series: [
                  {
                    name: "03 tháng",
                    data: res.metadata.data.map((i) => i.package_3),
                    color: "#8979FF",
                  },
                  {
                    name: "06 tháng",
                    data: res.metadata.data.map((i) => i.package_6),
                    color: "#FF928A",
                  },
                  {
                    name: "12 tháng",
                    data: res.metadata.data.map((i) => i.package_12),
                    color: "#3CC3DF",
                  },
                ],
                categories: res.metadata.data.map((i) =>
                  this.convertDateFormat(i.time)
                ),
              };
              this.chartOptionsOpenReport = {
                series: data.series,
                chart: {
                  type: "bar",
                  height: 400,
                },
                plotOptions: {
                  bar: {
                    dataLabels: {
                      position: "top", // Hiển thị số lượng trên đầu mỗi cột
                    },
                  },
                },
                dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val; // Hiển thị số lượng trực tiếp trên từng cột
                  },
                  style: {
                    fontSize: "12px",
                    colors: ["#000"], // Màu chữ hiển thị trên cột
                  },
                },
                stroke: {
                  show: true,
                  width: 1,
                  colors: ["transparent"],
                },
                xaxis: {
                  categories: data.categories,
                },
                yaxis: {
                  title: { text: "Số lượng loa" },
                },
                fill: {
                  opacity: 1,
                },
                annotations: {
                  yaxis: [
                    {
                      y: Math.round(res.metadata.average), // Làm tròn số
                      borderColor: "#00B69B",
                      strokeDashArray: 4,
                      label: {
                        position: "right",
                        borderWidth: 0,
                        offsetX: -50, // Dịch sang trái
                        style: {
                          color: "#00B69B",
                          background: "transparent",
                          fontSize: "14px",
                        },
                        text: `Trung bình: ${Math.round(res.metadata.average)}`, // Hiển thị số nguyên
                      },
                    },
                  ],
                },

                tooltip: {
                  enabled: true,
                  shared: true,
                  intersect: false,
                  custom: function ({
                    series,
                    seriesIndex,
                    dataPointIndex,
                    w,
                  }) {
                    const total = series.reduce(
                      (sum, s) => sum + (s[dataPointIndex] || 0),
                      0
                    );
                    return `
                    <div style="padding: 8px; background: white; border-radius: 5px; box-shadow: 0px 0px 10px rgba(0,0,0,0.1);">
                      <strong>${w.globals.labels[dataPointIndex]}</strong>
                      <br/>
                      <span style="font-size: 14px; color: #333;">Tổng: <strong>${total}</strong></span>
                    </div>
                  `;
                  },
                },
                legend: {
                  position: "bottom",
                },
                grid: {
                  show: true,
                  borderColor: "#f1f1f1",
                },
              };

              break;

            case "Loại loa":
              data = {
                series: [
                  {
                    name: "Loa 4G",
                    data: res.metadata.data.map((i) => i.device_4g),
                    color: "#8979FF",
                  },
                  {
                    name: "Loa Wifi",
                    data: res.metadata.data.map((i) => i.device_wifi),
                    color: "#FF928A",
                  },
                ],
                categories: res.metadata.data.map((i) =>
                  this.convertDateFormat(i.time)
                ),
              };
              this.chartOptionsOpenReport = {
                series: data.series,
                chart: {
                  type: "bar",
                  height: 400,
                },
                plotOptions: {
                  bar: {},
                },
                dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val; // Hiển thị số lượng trực tiếp trên từng cột
                  },
                  style: {
                    fontSize: "12px",
                    colors: ["#000"], // Màu chữ hiển thị trên cột
                  },
                },
                stroke: {
                  show: true,
                  width: 1,
                  colors: ["transparent"],
                },
                xaxis: {
                  categories: data.categories,
                },
                yaxis: {
                  title: { text: "Số lượng loa" },
                },
                fill: {
                  opacity: 1,
                },
                annotations: {
                  yaxis: [
                    {
                      y: Math.round(res.metadata.average), // Làm tròn số
                      borderColor: "#00B69B",
                      strokeDashArray: 4,
                      label: {
                        position: "right",
                        borderWidth: 0,
                        offsetX: -50, // Dịch sang trái
                        style: {
                          color: "#00B69B",
                          background: "transparent",
                          fontSize: "14px",
                        },
                        text: `Trung bình: ${Math.round(res.metadata.average)}`, // Hiển thị số nguyên
                      },
                    },
                  ],
                },
                tooltip: {
                  enabled: true,
                  shared: true,
                  intersect: false,
                  custom: function ({
                    series,
                    seriesIndex,
                    dataPointIndex,
                    w,
                  }) {
                    const total = series.reduce(
                      (sum, s) => sum + (s[dataPointIndex] || 0),
                      0
                    );
                    return `
                      <div style="padding: 8px; background: white; border-radius: 5px; box-shadow: 0px 0px 10px rgba(0,0,0,0.1);">
                        <strong>${w.globals.labels[dataPointIndex]}</strong>
                        <br/>
                        <span style="font-size: 14px; color: #333;">Tổng: <strong>${total}</strong></span>
                      </div>
                    `;
                  },
                },
                legend: {
                  position: "bottom",
                },
                grid: {
                  show: true,
                  borderColor: "#f1f1f1",
                },
              };
              break;

            case "Phương thức nhận hàng":
              data = {
                series: [
                  {
                    name: "Giao hàng",
                    data: res.metadata.data.map((i) => i.online),
                    color: "#8979FF",
                  },
                  {
                    name: "Trực tiếp",
                    data: res.metadata.data.map((i) => i.direct),
                    color: "#FF928A",
                  },
                ],
                categories: res.metadata.data.map((i) =>
                  this.convertDateFormat(i.time)
                ),
              };
              this.chartOptionsOpenReport = {
                series: data.series,
                chart: {
                  type: "bar",
                  height: 400,
                },
                plotOptions: {
                  bar: {},
                },
                dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val; // Hiển thị số lượng trực tiếp trên từng cột
                  },
                  style: {
                    fontSize: "12px",
                    colors: ["#000"], // Màu chữ hiển thị trên cột
                  },
                },
                stroke: {
                  show: true,
                  width: 1,
                  colors: ["transparent"],
                },
                xaxis: {
                  categories: data.categories,
                },
                yaxis: {
                  title: { text: "Số lượng loa" },
                },
                fill: {
                  opacity: 1,
                },
                annotations: {
                  yaxis: [
                    {
                      y: Math.round(res.metadata.average), // Làm tròn số
                      borderColor: "#00B69B",
                      strokeDashArray: 4,
                      label: {
                        position: "right",
                        borderWidth: 0,
                        offsetX: -50, // Dịch sang trái
                        style: {
                          color: "#00B69B",
                          background: "transparent",
                          fontSize: "14px",
                        },
                        text: `Trung bình: ${Math.round(res.metadata.average)}`, // Hiển thị số nguyên
                      },
                    },
                  ],
                },
                tooltip: {
                  enabled: true,
                  shared: true,
                  intersect: false,
                  custom: function ({
                    series,
                    seriesIndex,
                    dataPointIndex,
                    w,
                  }) {
                    const total = series.reduce(
                      (sum, s) => sum + (s[dataPointIndex] || 0),
                      0
                    );
                    return `
                      <div style="padding: 8px; background: white; border-radius: 5px; box-shadow: 0px 0px 10px rgba(0,0,0,0.1);">
                        <strong>${w.globals.labels[dataPointIndex]}</strong>
                        <br/>
                        <span style="font-size: 14px; color: #333;">Tổng: <strong>${total}</strong></span>
                      </div>
                    `;
                  },
                },
                legend: {
                  position: "bottom",
                },
                grid: {
                  show: true,
                  borderColor: "#f1f1f1",
                },
              };
              break;

            case "Tình trạng đơn hàng":
              data = {
                series: [
                  {
                    name: "Chờ xác nhận",
                    data: res.metadata.data.map((i) => i.pending_confirm),
                    color: "#FFA500", // cam đậm
                  },
                  {
                    name: "Đã xác nhận",
                    data: res.metadata.data.map((i) => i.confirmed),
                    color: "#4CAF50", // xanh lá tươi
                  },
                  {
                    name: "Trả hàng",
                    data: res.metadata.data.map((i) => i.return),
                    color: "#E91E63", // hồng đậm
                  },
                  {
                    name: "Đang giao",
                    data: res.metadata.data.map((i) => i.delivering),
                    color: "#03A9F4", // xanh dương sáng
                  },
                  {
                    name: "Đã giao",
                    data: res.metadata.data.map((i) => i.delivered),
                    color: "#3F51B5", // xanh navy
                  },
                  {
                    name: "Hoàn tiền",
                    data: res.metadata.data.map((i) => i.refunded),
                    color: "#009688", // xanh ngọc
                  },
                  {
                    name: "Sẵn sàng để lấy hàng",
                    data: res.metadata.data.map((i) => i.ready_to_pick),
                    color: "#8BC34A", // xanh lá non
                  },
                  {
                    name: "Hủy",
                    data: res.metadata.data.map((i) => i.cancel),
                    color: "#9E9E9E", // xám trung tính
                  }
                ],
                categories: res.metadata.data.map((i) =>
                  this.convertDateFormat(i.time)
                ),
              };
              this.chartOptionsOpenReport = {
                series: data.series,
                chart: {
                  type: "bar",
                  height: 400,
                  stacked: true,
                },
                plotOptions: {
                  bar: {
                    horizontal: false,
                    columnWidth: "50%",
                  },
                },
                dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val; // Hiển thị số lượng trực tiếp trên từng cột
                  },
                  style: {
                    fontSize: "12px",
                    colors: ["#000"], // Màu chữ hiển thị trên cột
                  },
                },
                stroke: {
                  show: true,
                  width: 1,
                  colors: ["transparent"],
                },
                xaxis: {
                  categories: data.categories,
                },
                yaxis: {
                  title: { text: "" },
                },
                fill: {
                  opacity: 1,
                },
                annotations: {
                  yaxis: [
                    {
                      y: Math.round(res.metadata.average), // Làm tròn số
                      borderColor: "#00B69B",
                      strokeDashArray: 4,
                      label: {
                        position: "right",
                        borderWidth: 0,
                        offsetX: -50, // Dịch sang trái
                        style: {
                          color: "#00B69B",
                          background: "transparent",
                          fontSize: "14px",
                        },
                        text: `Trung bình: ${Math.round(res.metadata.average)}`, // Hiển thị số nguyên
                      },
                    },
                  ],
                },
                tooltip: {
                  enabled: true,
                  shared: true,
                  intersect: false,
                  custom: function ({
                    series,
                    seriesIndex,
                    dataPointIndex,
                    w,
                  }) {
                    const total = series.reduce(
                      (sum, s) => sum + (s[dataPointIndex] || 0),
                      0
                    );
                    return `
                      <div style="padding: 8px; background: white; border-radius: 5px; box-shadow: 0px 0px 10px rgba(0,0,0,0.1);">
                        <strong>${w.globals.labels[dataPointIndex]}</strong>
                        <br/>
                        <span style="font-size: 14px; color: #333;">Tổng: <strong>${total}</strong></span>
                      </div>
                    `;
                  },
                },
                legend: {
                  position: "bottom",
                },
                grid: {
                  show: true,
                  borderColor: "#f1f1f1",
                },
              };
              break;

            case "Cửa hàng active":
              data = {
                series: [
                  {
                    name: "Tỉ lệ cửa hàng active",
                    data: res.metadata.packages.map((i) => i.total_all),
                    color: "#8979FF",
                  },
                ],
                categories: res.metadata.packages.map((i) =>
                  this.convertDateFormat(i.time)
                ),
              };
              this.chartOptionsOpenReport = {
                chart: {
                  type: "area",
                  height: 350,
                  toolbar: { show: false },
                },
                series: data.series,
                xaxis: {
                  categories: Array.from({ length: 31 }, (_, i) =>
                    (i + 1).toString().padStart(2, "0")
                  ),
                },
                yaxis: {
                  title: { text: "Tỉ lệ loa active%" },
                },
                stroke: {
                  curve: "straight",
                  width: 2,
                  colors: ["#8979FF"],
                },
                dataLabels: {
                  enabled: false,
                },
                annotations: {
                  yaxis: [
                    {
                      y: Math.round(res.metadata.average), // Làm tròn số
                      borderColor: "#00B69B",
                      strokeDashArray: 4,
                      label: {
                        position: "right",
                        borderWidth: 0,
                        offsetX: -50, // Dịch sang trái
                        style: {
                          color: "#00B69B",
                          background: "transparent",
                          fontSize: "14px",
                        },
                        text: `Trung bình: ${Math.round(res.metadata.average)}`, // Hiển thị số nguyên
                      },
                    },
                  ],
                },
                fill: {
                  type: "gradient",
                  gradient: {
                    shadeIntensity: 0.8,
                    opacityFrom: 0.8,
                    opacityTo: 0.5,
                    stops: [0, 100],
                  },
                  colors: ["#8979FF"],
                },
                colors: ["#8979FF"],
                legend: {
                  position: "bottom",
                },
                tooltip: {
                  enabled: true,
                  y: {
                    formatter: (value) => value + " %",
                  },
                  shared: true,
                  intersect: false,
                },
                markers: {
                  size: 4,
                  strokeWidth: 2,
                  hover: {
                    size: 6,
                  },
                  colors: ["#8979FF"],
                  strokeColors: "#fff",
                  discrete: [],
                },
              };
              break;

            case "Kênh bán":
              data = {
                series: [
                  {
                    name: "DNS",
                    data: res.metadata.data.map((i) => i.total_dns),
                  },
                  {
                    name: "MB",
                    data: res.metadata.data.map((i) => i.total_mb),
                  },
                  {
                    name: "VCC",
                    data: res.metadata.data.map((i) => i.total_vcc),
                  },
                  {
                    name: "Marketing Online",
                    data: res.metadata.data.map(
                      (i) => i.total_marketing_online
                    ),
                  },
                ],
                categories: res.metadata.data.map((i) =>
                  this.convertDateFormat(i.time)
                ),
              };
              this.chartOptionsOpenReport = {
                series: data.series,
                chart: {
                  type: "bar",
                  height: 400,
                  stacked: true,
                },
                plotOptions: {
                  bar: {
                    horizontal: false,
                    columnWidth: "50%",
                  },
                },
                dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val; // Hiển thị số lượng trực tiếp trên từng cột
                  },
                  style: {
                    fontSize: "12px",
                    colors: ["#000"], // Màu chữ hiển thị trên cột
                  },
                },
                stroke: {
                  show: true,
                  width: 1,
                  colors: ["transparent"],
                },
                xaxis: {
                  categories: data.categories,
                },
                yaxis: {
                  title: { text: "Số lượng loa" },
                },
                fill: {
                  opacity: 1,
                },
                annotations: {
                  yaxis: [
                    {
                      y: Math.round(res.metadata.average), // Làm tròn số
                      borderColor: "#00B69B",
                      strokeDashArray: 4,
                      label: {
                        position: "right",
                        borderWidth: 0,
                        offsetX: -50, // Dịch sang trái
                        style: {
                          color: "#00B69B",
                          background: "transparent",
                          fontSize: "14px",
                        },
                        text: `Trung bình: ${Math.round(res.metadata.average)}`, // Hiển thị số nguyên
                      },
                    },
                  ],
                },
                tooltip: {
                  enabled: true,
                  shared: true,
                  intersect: false,
                  custom: function ({
                    series,
                    seriesIndex,
                    dataPointIndex,
                    w,
                  }) {
                    const total = series.reduce(
                      (sum, s) => sum + (s[dataPointIndex] || 0),
                      0
                    );
                    return `
                    <div style="padding: 8px; background: white; border-radius: 5px; box-shadow: 0px 0px 10px rgba(0,0,0,0.1);">
                      <strong>${w.globals.labels[dataPointIndex]}</strong>
                      <br/>
                      <span style="font-size: 14px; color: #333;">Tổng: <strong>${total}</strong></span>
                    </div>
                  `;
                  },
                },
                legend: {
                  position: "bottom",
                },
                grid: {
                  show: true,
                  borderColor: "#f1f1f1",
                },
              };
              break;
          }
          this.loadingState.chartOpenReport = false;
        },
        error: (e) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.translate.instant(e || "Lỗi tải dữ liệu")
          );
        },
      });
  }

  getMonthlyReport() {
    this.loadingState.chartMonthlyReport = true;
    this.apiService
      .getList(
        `dashboard/cumulative-report?partnerOption=${this.partnerOption}&&type=${this.selectedMonthlyOption.value}`
      )
      .subscribe({
        next: (res) => {
          const currentDate = new Date();
          const currentMonth = currentDate.getMonth() + 1;
          const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
          const averageCurentMonth =
            res.metadata.currentMonth.length > 0
              ? res.metadata.currentMonth.reduce(
                (total, num) => total + num,
                0
              ) / res.metadata.currentMonth.length
              : 0;
          const averagePreviousMonth =
            res.metadata.lastMonth.length > 0
              ? res.metadata.lastMonth.reduce((total, num) => total + num, 0) /
              res.metadata.lastMonth.length
              : 0;
          this.chartOptionsMonthlyReport = {
            chart: {
              type: "area",
              height: 350,
              toolbar: { show: false },
            },
            series: [
              {
                name: "Tháng " + previousMonth,
                data: res.metadata.lastMonth,
                color: "#8979FF",
              },
              {
                name: "Tháng " + currentMonth,
                data: res.metadata.currentMonth,
                color: "#FF928A",
              },
            ],
            xaxis: {
              categories: Array.from({ length: 31 }, (_, i) =>
                (i + 1).toString().padStart(2, "0")
              ),
            },
            yaxis: {
              title: { text: this.selectedMonthlyOption.type },
            },
            stroke: {
              curve: "straight",
              width: 2,
              colors: ["#8979FF", "#FF928A"],
            },
            dataLabels: {
              enabled: false,
            },
            annotations: {
              yaxis: [
                {
                  y: Math.round(averageCurentMonth), // Làm tròn số
                  borderColor: "#FF928A",
                  strokeDashArray: 4,
                  label: {
                    position: "right",
                    borderWidth: 0,
                    offsetX: -50, // Dịch sang trái
                    style: {
                      color: "#FF928A",
                      background: "transparent",
                      fontSize: "14px",
                    },
                    text: `Trung bình: ${Math.round(averageCurentMonth)}`, // Hiển thị số nguyên
                  },
                },
                {
                  y: Math.round(averagePreviousMonth), // Làm tròn số
                  borderColor: "#8979FF",
                  strokeDashArray: 4,
                  label: {
                    position: "right",
                    borderWidth: 0,
                    offsetX: -50, // Dịch sang trái
                    style: {
                      color: "#8979FF",
                      background: "transparent",
                      fontSize: "14px",
                    },
                    text: `Trung bình: ${Math.round(averagePreviousMonth)}`, // Hiển thị số nguyên
                  },
                },
              ],
            },


            fill: {
              type: "gradient",
              gradient: {
                shadeIntensity: 0.8,
                opacityFrom: 0.8,
                opacityTo: 0.5,
                stops: [0, 100],
              },
              colors: ["#8979FF", "#FF928A"],
            },
            colors: ["#8979FF", "#FF928A"],
            legend: {
              position: "bottom",
            },
            tooltip: {
              shared: true,
              intersect: false,
            },
            markers: {
              size: 4,
              strokeWidth: 2,
              hover: {
                size: 6,
              },
              colors: ["#8979FF", "#FF928A"],
              strokeColors: "#fff",
              discrete: [],
            },
          };
          this.loadingState.chartMonthlyReport = false;
        },
        error: (e) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.translate.instant(e || "Lỗi tải dữ liệu")
          );
        },
      });
  }

  getOpenBranchReport() {
    this.loadingState.chartOpenBranchReport = true;
    let chartOptions: any = {
      series: [
        {
          name: "Loa",
          data: [],
        },
      ],
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "50%",
        },
      },
      dataLabels: {
        enabled: true,
      },
      xaxis: {
        categories: [],
      },
    };
    this.apiService
      .getList(
        `dashboard/new-report-open-branch?partnerOption=${this.partnerOption}`
      )
      .subscribe({
        next: (res) => {
          this.chartOptionsOpenBranchReport = [];
          // get month
          const lmonth = res.metadata.data[0].month?.split("-")[1];
          const cmonth = res.metadata.data[1].month?.split("-")[1];
          const lastMonth = lmonth;
          const curentMonth = cmonth;
          // max quantity
          const quantities0 = res.metadata.data[0].topSellers?.map(
            (i) => i.total_quantity
          );
          const quantities1 = res.metadata.data[1].topSellers?.map(
            (i) => i.total_quantity
          );
          const maxQuantity =
            Math.max(...quantities0, ...quantities1) +
            Math.max(...quantities0, ...quantities1) / 3;

          const isPartnerOperation = this.role === "branch_operation";
          const entityLabel = isPartnerOperation ? "RM/UB" : "ĐVKD";

          const formatCategory = (i) =>
            isPartnerOperation ? `${i.code_rm}` : i.full_name;

          const topLastMonth = {
            title: `Top 5 ${entityLabel} tháng ${lastMonth}`,
            option: {
              ...chartOptions,
              fill: {
                colors: ["#8979FF"],
              },
              series: [
                {
                  name: "Số lượng",
                  data: res.metadata.data[0].topSellers.map(
                    (i) => i.total_quantity
                  ),
                },
              ],
              xaxis: {
                categories: res.metadata.data[0].topSellers.map(formatCategory),
                max: maxQuantity,
              },
              tooltip: {
                x: {
                  formatter: (_val, { dataPointIndex }) => {
                    const i = res.metadata.data[0].topSellers[dataPointIndex];
                    return `${i.code_rm} - ${i.full_name}`;
                  }
                }
              }
        
            },
          };

          const botLastMonth = {
            title: `Bottom 5 ${entityLabel} tháng ${lastMonth}`,
            option: {
              ...chartOptions,
              fill: {
                colors: ["#00B69B"],
              },
              series: [
                {
                  name: "Số lượng",
                  data: res.metadata.data[0].bottomSellers.map(
                    (i) => i.total_quantity
                  ),
                },
              ],
              xaxis: {
                categories:
                  res.metadata.data[0].bottomSellers.map(formatCategory),
                max: maxQuantity,
              },
              tooltip: {
                x: {
                  formatter: (_val, { dataPointIndex }) => {
                    const i = res.metadata.data[0].bottomSellers[dataPointIndex];
                    return `${i.code_rm} - ${i.full_name}`;
                  }
                }
              }
            },
          };

          const topCurrentMonth = {
            title: `Top 5 ${entityLabel} tháng ${curentMonth}`,
            option: {
              ...chartOptions,
              fill: {
                colors: ["#459CEC"],
              },
              series: [
                {
                  name: "Số lượng",
                  data: res.metadata.data[1].topSellers.map(
                    (i) => i.total_quantity
                  ),
                },
              ],
              xaxis: {
                categories: res.metadata.data[1].topSellers.map(formatCategory),
                max: maxQuantity,
              },
              tooltip: {
                x: {
                  formatter: (_val, { dataPointIndex }) => {
                    const i = res.metadata.data[1].topSellers[dataPointIndex];
                    return `${i.code_rm} - ${i.full_name}`;
                  }
                }
              }
            },
          };

          const botCurrentMonth = {
            title: `Bottom 5 ${entityLabel} tháng ${curentMonth}`,
            option: {
              ...chartOptions,
              fill: {
                colors: ["#F2785D"],
              },
              series: [
                {
                  name: "Số lượng",
                  data: res.metadata.data[1].bottomSellers.map(
                    (i) => i.total_quantity
                  ),
                },
              ],
              xaxis: {
                categories:
                  res.metadata.data[1].bottomSellers.map(formatCategory),
                max: maxQuantity,
              },
              tooltip: {
                x: {
                  formatter: (_val, { dataPointIndex }) => {
                    const i = res.metadata.data[1].bottomSellers[dataPointIndex];
                    return `${i.code_rm} - ${i.full_name}`;
                  }
                }
              }
            },
          };

          this.chartOptionsOpenBranchReport = [
            topCurrentMonth,
            botCurrentMonth,
            topLastMonth,
            botLastMonth,
          ];
          this.loadingState.chartOpenBranchReport = false;
        },
        error: (e) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.translate.instant(e || "Lỗi tải dữ liệu")
          );
        },
      });
  }
}
